module.exports = __webpack_public_path__ + "media/components/maps/apps/icons/somewhatNegative-6c85da7a19a6027ddd64ea88b0610691.png";